import { AdditionalInfo } from '@reg/shared/model/additional-info.model';

/**
 * Model to hold collected additional information
 */
export class AdditionalInfoItem {
    public id: string = null;
    public additionalInfo: AdditionalInfo = null;
    public eventId: string = null;
    public value: number = null;
    public entityName: string = null;
    public entityGuid: string = null;

    public clone(): AdditionalInfoItem {
        const clone: AdditionalInfoItem = new AdditionalInfoItem();
        clone.id = this.id;
        clone.value = this.value;
        clone.additionalInfo = this.additionalInfo && this.additionalInfo.clone();
        clone.entityName = this.entityName;
        clone.entityGuid = this.entityGuid;
        clone.eventId = this.eventId;

        return clone;
    }

    /**
     * Serialize to a json api format
     */
    public serialize(): string {
        const json: any = {
            data: {
                id: this.id,
                type: 'additionalInfoItem',
                attributes: {
                    value: this.value,
                    entityGuid: this.entityGuid,
                    entityName: this.entityName,
                },
                relationships: {
                    additionalInfo: {
                        data: { type: 'additionalInfo', id: this.additionalInfo.id },
                    },
                },
            },
        };

        return JSON.stringify(json);
    }

    /**
     * Deserialize from a json api format
     */
    public deserialize(json: any, included: any[] = []): AdditionalInfoItem {
        const data: any = json.data || json;
        const attrs: any = data.attributes || {};
        const relationships: any = data.relationships || {};
        included = included || [];

        this.id = data.id;
        this.value = attrs.value;
        this.entityName = attrs.entityName;
        this.entityGuid = attrs.entityGuid;
        this.eventId = attrs.eventId;
        this.additionalInfo = new AdditionalInfo(attrs.additionalInfoId);

        const additionalInfoRelationship: any = relationships.additionalInfo;
        if (additionalInfoRelationship) {
            const additionalInfoId: string = additionalInfoRelationship.data.id;
            const additionalInfoJson: any = included.filter(
                (i: any) => i.type === 'additionalInfo' && i.id === additionalInfoId,
            )[0];

            if (additionalInfoJson) {
                this.additionalInfo = (new AdditionalInfo()).deserialize(additionalInfoJson, included);
            }
        }

        return this;
    }
}
